import { Component, computed, HostBinding, input } from '@angular/core';
import { Color, Size } from '../common/types';

@Component({
    selector: 'app-icon',
    standalone: true,
    template: ``,
    styleUrl: './icon.component.css',
    host: {
        '[attr.data-size]': 'size()',
        '[style]': 'style()',
    },
})
export class Icon {
    @HostBinding('class') get hostClass() {
        return this.$class();
    }

    name = input.required<string>();

    // Iconify API는 `prefix:name.svg` 형식을 더 이상 지원하지 않음 → `prefix/name.svg`로 변환
    _name = computed(() => encodeURI(`https://api.iconify.design/${this.name().replace(':', '/')}.svg`));

    size = input<Size>('md');
    color = input<Color>('primary');
    $class = input<string>('', { alias: 'class' });

    style = computed(() => ({
        maskSize: 'cover',
        maskImage: `url(${this._name()})`,
        webkitMaskSize: 'cover',
        webkitMaskImage: `url(${this._name()})`,
        display: 'inline-block',
        background: 'currentColor',
    }));

    class = computed(() => `${this.size() ? `${this.size()}` : ''}  ${this.color() ? this.color() : ''}`);
}
